export default function DiagramMakerSupport() {
  return (
    <main className="min-h-screen bg-[#FBFAF6] text-[#26313B]">
      <section className="mx-auto max-w-3xl px-6 py-12">
        <header className="mb-8 text-center">
          <h1 className="text-4xl font-extrabold tracking-tight text-[#A8720E]">
            Support - Diagram Maker
          </h1>
          <p className="mt-2 text-sm text-[#5B6B7C]">
            Help, troubleshooting, and contact details for Diagram Maker.
          </p>
          <p className="mt-1 text-xs text-[#8A93A2]">
            Published by <span className="font-semibold">Cosmovex</span>
          </p>
        </header>

        <div className="space-y-8 leading-relaxed text-[#3D4B59]">
          <h2 className="text-2xl font-bold text-[#A8720E]">
            Frequently Asked Questions
          </h2>

          <div className="space-y-6">
            <div>
              <h3 className="text-lg font-semibold text-[#26313B]">
                How do I create a diagram?
              </h3>
              <p className="mt-1">
                Tap Create Diagram and choose the Visual Editor to drag shapes
                onto a canvas, or the Mermaid Code editor to build a diagram
                from text with a live preview. You can also start from a
                ready-made template.
              </p>
            </div>

            <div>
              <h3 className="text-lg font-semibold text-[#26313B]">
                Which diagram types are supported?
              </h3>
              <p className="mt-1">
                Flowcharts, mind maps, UML class and sequence diagrams,
                entity-relationship (ER) diagrams, BPMN, org charts, gantt
                charts, state diagrams and pie charts.
              </p>
            </div>

            <div>
              <h3 className="text-lg font-semibold text-[#26313B]">
                What is the quick-insert toolbar?
              </h3>
              <p className="mt-1">
                In the Mermaid code editor, a toolbar above the keyboard places
                common symbols — arrows, nodes, labels and more — one tap away.
                It adapts to the diagram type you are editing.
              </p>
            </div>

            <div>
              <h3 className="text-lg font-semibold text-[#26313B]">
                Does the app work offline?
              </h3>
              <p className="mt-1">
                Yes. Creating, editing and exporting diagrams works offline.
                Internet access is only required for services such as ads,
                analytics, or store links.
              </p>
            </div>

            <div>
              <h3 className="text-lg font-semibold text-[#26313B]">
                Can I export and share my diagrams?
              </h3>
              <p className="mt-1">
                Yes. You can export your diagram as a PNG image, an SVG vector
                file, or a PDF document, and share it using the system share
                sheet.
              </p>
            </div>

            <div>
              <h3 className="text-lg font-semibold text-[#26313B]">
                What does the Pro upgrade include?
              </h3>
              <p className="mt-1">
                Diagram Maker is free to use. A single one-time Pro upgrade
                removes ads. There is no subscription and no recurring charge.
              </p>
            </div>

            <div>
              <h3 className="text-lg font-semibold text-[#26313B]">
                Why am I seeing ads?
              </h3>
              <p className="mt-1">
                Some versions of the app show ads to support ongoing
                development, maintenance, and feature updates.
              </p>
            </div>
          </div>

          <h2 className="text-2xl font-bold text-[#A8720E]">Contact Support</h2>
          <p>
            If you need help, have feedback, or want to report an issue, email{" "}
            <a
              href="mailto:trionapps@gmail.com"
              className="text-[#0F6BBF] underline"
            >
              trionapps@gmail.com
            </a>
            . We typically respond within 24-48 hours.
          </p>

          <h2 className="text-2xl font-bold text-[#A8720E]">Report a Bug</h2>
          <p>
            To help us resolve issues faster, include the following in your
            message when possible:
          </p>
          <ul className="list-disc pl-6 space-y-2">
            <li>Your device model and OS version</li>
            <li>The app version shown in Settings</li>
            <li>A short description of the issue</li>
            <li>Steps to reproduce the problem</li>
          </ul>

          <h2 className="text-2xl font-bold text-[#A8720E]">App Information</h2>
          <ul className="list-disc pl-6 space-y-2">
            <li>
              <strong>App Name:</strong> Diagram Maker
            </li>
            <li>
              <strong>Developer:</strong> Cosmovex
            </li>
            <li>
              <strong>Contact Email:</strong>{" "}
              <a
                href="mailto:trionapps@gmail.com"
                className="text-[#0F6BBF] underline"
              >
                trionapps@gmail.com
              </a>
            </li>
            <li>
              <strong>Privacy Policy:</strong>{" "}
              <a
                href="https://cosmovexapps.com/apps/diagrammaker/privacy-policy"
                className="text-[#0F6BBF] underline"
              >
                https://cosmovexapps.com/apps/diagrammaker/privacy-policy
              </a>
            </li>
            <li>
              <strong>Support URL:</strong>{" "}
              <a
                href="https://cosmovexapps.com/apps/diagrammaker/support"
                className="text-[#0F6BBF] underline"
              >
                https://cosmovexapps.com/apps/diagrammaker/support
              </a>
            </li>
          </ul>
        </div>

        <footer className="mt-12 border-t border-[#E1DCCE] pt-4 text-center text-sm text-[#8A93A2]">
          © {new Date().getFullYear()} Cosmovex - All rights reserved.
        </footer>
      </section>
    </main>
  );
}
